/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import moment from "moment-timezone";
import i18n from "i18next";
import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import { currencyAmountFromCents } from "openstack-uicore-foundation/lib/utils/money";
import {
  DATETIME_FORMAT,
  DEFAULT_PER_PAGE,
  MILISECONDS
} from "../utils/constants";
import {
  RECEIVE_SPONSOR_ORDER,
  RECEIVE_SPONSOR_ORDERS,
  REQUEST_SPONSOR_ORDER,
  CLEAR_SPONSOR_ORDER
} from "../actions/sponsor-actions";
import { normalizeOrder } from "../utils/methods";

const DEFAULT_STATE = {
  orders: [],
  currentPage: 1,
  lastPage: 1,
  perPage: DEFAULT_PER_PAGE,
  total: 0,
  currentOrder: null
};

const sponsorOrdersListReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RECEIVE_SPONSOR_ORDERS: {
      const {
        data,
        total,
        last_page: lastPage,
        per_page: perPage,
        current_page: currentPage
      } = payload.response;

      const orders = data.map(mapOrderData);

      return {
        ...state,
        orders,
        total,
        lastPage,
        perPage,
        currentPage
      };
    }
    case REQUEST_SPONSOR_ORDER: {
      return { ...state, currentOrder: null };
    }
    case RECEIVE_SPONSOR_ORDER: {
      const data = payload.response;
      const currentOrder = normalizeOrder(data);

      return { ...state, currentOrder };
    }
    case CLEAR_SPONSOR_ORDER: {
      return { ...state, currentOrder: null };
    }
    default:
      return state;
  }
};

const mapOrderData = (order) => ({
  id: order.id,
  order_number: order.number,
  purchased: order.purchased_date
    ? moment(order.purchased_date * MILISECONDS).format(DATETIME_FORMAT)
    : i18n.t("my_orders.details_page.pending"),
  payment_method: order.payment_method,
  status: order.status,
  amount: currencyAmountFromCents(order.raw_amount),
  net_amount: order.net_amount,
  card_payment_enabled_at: order.card_payment_enabled_at,
  payment_status: order.payment_status
});

export default sponsorOrdersListReducer;
